import {
    ADMINGETWALLETTRANSACTIONLISTBYID_SUCCESS,
    ADMINGETWALLETTRANSACTIONLISTBYID_FAILED,
    RESET_GETWALLETTRANSACTIONLISTBYIDADMIN,
    LOADING_GETWALLETTRANSACTIONLISTBYIDADMIN,
    NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYIDADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETWALLETTRANSACTIONLISTBYIDADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case ADMINGETWALLETTRANSACTIONLISTBYID_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case ADMINGETWALLETTRANSACTIONLISTBYID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYIDADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETWALLETTRANSACTIONLISTBYIDADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
